import React, { useEffect } from 'react'
import { Box, Snackbar, Alert } from '@mui/material'
import useAlert from '../hooks/useAlert'

export default function SurveyAlert({ errorText, successAlertOpen, errorAlertOpen, setErrorAlertOpen, insertId, setBackDropLoading, handleBackDropLoadingToggle, setSuccessAlertOpen, surveyType }) {
    // surveyType 1 = Land and Building survey, 2 = Billboard survey
    const { handleSuccessAlertClose, handleErrorAlertClose } = useAlert()
    return (
        <Box>
            <Snackbar
                open={successAlertOpen}
                autoHideDuration={2000}
                onClose={(event, reason) => {
                    if (surveyType === 1) {
                        handleSuccessAlertClose(event, reason, insertId, setBackDropLoading, handleBackDropLoadingToggle, setSuccessAlertOpen, '../survey/print')
                    }
                    if (surveyType === 2) {
                        handleSuccessAlertClose(event, reason, insertId, setBackDropLoading, handleBackDropLoadingToggle, setSuccessAlertOpen, '../survey/billboard/print')
                    }
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <Alert variant='filled' severity="success" sx={{ width: '100%' }}>
                    บันทึกข้อมูลสำเร็จ!
                </Alert>
            </Snackbar>
            <Snackbar
                open={errorAlertOpen}
                onClose={(event, reason) => {
                    handleErrorAlertClose(event, reason, setBackDropLoading, handleBackDropLoadingToggle, setErrorAlertOpen)
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <Alert variant="filled" severity="error" sx={{ width: '100%' }}>
                    {errorText}
                </Alert>
            </Snackbar>
        </Box>
    )
}